<template>
  <div>
    <div>
      <div class="w-full flex mb-4">
        <report-date-picker v-model="dateRange" @change="getReports"/>
      </div>
      <data-table :entity="entity"
                  :columns="columns"
                  :data="jobBoards"
                  :is-loading="loading"
                  :disablePermissionChecks="true"
                  operations="refresh,edit"
                  rowNavigationKey="job_board_id"
                  ref="table">
        <template v-slot:total="{ row }">
          <strong>{{ row.total }}</strong>
        </template>
      </data-table>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <orders-per-client-report :date-from="dateFrom"
                                  :date-till="dateTill"
                                  :all-job-boards="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import get from 'lodash/get'
import OrdersPerClientReport from 'src/views/admin/reports/OrdersPerClientReport'
import ReportService from 'src/services/ReportService'
import ReportDatePicker from 'src/views/admin/reports/ReportDatePicker'
import entities from 'src/config/entities'
import ReportsWarning from 'src/views/admin/reports/ReportsWarning'
import { getDefaultRange } from '@/views/admin/reports/defaultReportRange'

export default {
  name: 'ecommerce-job-board-reports',
  components: {
    OrdersPerClientReport,
    ReportDatePicker,
    ReportsWarning,
  },
  data () {
    const year = new Date().getFullYear()
    const defaultRange = getDefaultRange()
    return {
      year,
      defaultRange,
      dateRange: [...defaultRange],
      loading: false,
      entity: entities.JOB_BOARD,
      jobBoards: []
    }
  },
  computed: {
    columns () {
      return [
        {
          prop: 'job_board_name',
          label: this.$t('generic.jobBoard'),
          minWidth: '140px'
        },
        {
          prop: 'total',
          label: this.$t('generic.jobs'),
          minWidth: '140px'
        }
      ]
    },
    dateFrom () {
      return get(this.dateRange, '[0]', this.defaultRange[0])
    },
    dateTill () {
      return get(this.dateRange, '[1]', this.defaultRange[1])
    },
  },
  methods: {
    async getReports () {
      try {
        this.loading = true
        const {data} = await ReportService.get({
          model: 'orders',
          group: 'job_boards',
          select: 'id,total,job_board',
          date_range: 'custom',
          date_from: this.dateFrom,
          date_till: this.dateTill,
          sort: 'date_month',
        })
        this.jobBoards = data.results
      } finally {
        this.loading = false
      }
    },
  },
  mounted () {
    this.getReports()
  }
}
</script>
<style>
</style>
